import { render, staticRenderFns } from "./VgTextTrack.vue?vue&type=template&id=72be7f2a&scoped=true&"
import script from "./VgTextTrack.vue?vue&type=script&lang=js&"
export * from "./VgTextTrack.vue?vue&type=script&lang=js&"
import style0 from "./VgTextTrack.vue?vue&type=style&index=0&id=72be7f2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72be7f2a",
  null
  
)

export default component.exports